import { Heading, Stack } from "@chakra-ui/react";

import CustomWrapper from "components/Chakra/CustomWrapper";
import { useStoryblokTypeUser } from "contexts/StoryblokTypeUser";
import { UserExistsResponse } from "@ud/api";
import CardMotion from "components/Chakra/Card/CardMotion";
import CardVariant from "components/Chakra/Card/CardVariant";

type TypeSection = {
  id: UserExistsResponse["type"];
  title: string;
  subtitle: string;
  bgImage: string;
};

const items: Array<TypeSection> = [
  {
    id: "PRIVATE_LANDLORD",
    title: "Služby pro soukromé majitele",
    subtitle: "Majitel nemovitostí",
    bgImage: "/img/scenes/NewHomepage/keys.webp",
  },
  {
    id: "REAL_ESTATE_BROKER",
    title: "Nástroje pro realitní činnost",
    subtitle: "Realitní makléř",
    bgImage: "/img/scenes/NewHomepage/man-notebook.webp",
  },
  {
    id: "INTERESTED_IN_HOUSING",
    title: "Přehledné rozhraní pro domov na míru",
    subtitle: "Zájemce o bydlení",
    bgImage: "/img/scenes/NewHomepage/people-house.webp",
  },
];

const UserTypeSection = () => {
  const { setLocalStorageUserType, setViewTypeUserSection } =
    useStoryblokTypeUser();
  const handleClickCard = (id: UserExistsResponse["type"]) => {
    setLocalStorageUserType(id);
    setViewTypeUserSection(false);
  };

  return (
    <CustomWrapper mt="80px" maxW="1360px">
      <Heading textAlign="center">
        Pomáháme spokojeně bydlet, pronajímat i prodat
      </Heading>
      <Stack
        direction={{ base: "column", md: "row" }}
        mt={{ base: "24px", md: "40px" }}
        spacing={{ base: "20px" }}
        cursor="pointer"
      >
        {items.map(({ title, subtitle, id, bgImage }, index) => (
          <CardMotion
            key={index}
            content={
              <CardVariant
                type="IMAGE_BACKGROUND_WHITE"
                title={title}
                bgImage={{ scr: bgImage }}
                subTitle={subtitle}
              />
            }
            onClick={() => handleClickCard(id)}
            gridItemSetting={{ h: { base: "360px", md: "500px" }, flex: 1 }}
          />
        ))}
      </Stack>
    </CustomWrapper>
  );
};

export default UserTypeSection;
